import { Component, inject } from '@angular/core';
import { BuilderModule } from '@builder.io/angular';
import { BuilderDependencyDirective } from '@scalefast/ecommerce-core';
import { PAGE_DATA } from 'src/types/tokens/inject-tokens';

@Component({
  imports: [BuilderModule, BuilderDependencyDirective],
  standalone: true,
  selector: 'app-section-builder-container',
  styleUrls: [],
  template: `
    @if (section) {
      <builder-component sfBuilderDependency [name]="section" />
    }
  `,
})
export class AppSectionBuilderContainerComponent {
  private componentData: any = inject(PAGE_DATA, { optional: true });

  section: string | null = null;

  constructor() {
    if (this.componentData) {
      this.section = this.componentData.sectionId;
    }
  }
}
